import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba8516a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "model-content flex" }
const _hoisted_2 = { class: "left-menu" }
const _hoisted_3 = { class: "right-tabs" }
const _hoisted_4 = { class: "footer flex" }

import { withDefaults, ref, reactive, VNodeChild } from 'vue';
import { Modal, Menu } from 'ant-design-vue';
import defaultVue from './icon/default.vue';
import myIcon from './icon/index.vue';
import emitter from '@/utils/mitt';

interface MenuInfo {
  key: string;
  keyPath: string[];
  item: VNodeChild;
  domEvent: MouseEvent;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'iconModal',
  props: {
    visible: { type: Boolean, default: false },
    title: null,
    closable: { type: Boolean, default: true },
    type: { default: '' },
    close: null,
    ok: null
  },
  setup(__props: any) {

const props = __props as { visible: boolean, title: string, closable: boolean, type: any, close: (...args: any[]) => any, ok: (...args: any[]) => any };

const { Item } = Menu;
const aModal = Modal;
const aMenu = Menu;
const aMenuItem = Item;


const state = reactive({
  selectedKeys: [1],
});

const menuKey = ref<any>(0);
const handleClick = (e: MenuInfo) => {
  menuKey.value = e.key;
};

emitter.on('iconTips', (e: any) => {
  let arr = [
    {
      key: 1,
      value: '我的图标',
    },
    {
      key: 2,
      value: '默认图标',
    },
  ];
  let arr2 = [
    {
      key: 3,
      value: '我的背景',
    },
    {
      key: 4,
      value: '默认背景',
    },
  ];

  if (e == '图标') {
    state.selectedKeys = [1];
    menuKey.value = 1;
    menuItem.value = arr;
  } else {
    state.selectedKeys = [3];
    menuKey.value = 3;
    menuItem.value = arr2;
  }
});

const menuItem = ref();

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_unref(aModal), {
    visible: props.visible,
    centered: "",
    title: props.title,
    width: 910,
    wrapClassName: "icon-modal",
    closable: props.closable,
    onCancel: props.close,
    footer: null
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(aMenu), {
            selectedKeys: state.selectedKeys,
            "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((state.selectedKeys) = $event)),
            style: {"width":"150px"},
            mode: "vertical",
            onClick: handleClick
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.value, (item) => {
                return (_openBlock(), _createBlock(_unref(aMenuItem), {
                  key: item.key
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.value), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selectedKeys"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (menuKey.value == 2 || menuKey.value == 4)
            ? (_openBlock(), _createBlock(defaultVue, {
                key: 0,
                "data-source": {
            menuKey: menuKey.value,
          }
              }, null, 8, ["data-source"]))
            : _createCommentVNode("", true),
          (menuKey.value == 1 || menuKey.value == 3)
            ? (_openBlock(), _createBlock(myIcon, {
                key: 1,
                "data-source": {
            menuKey: menuKey.value,
            visible: props.visible,
          }
              }, null, 8, ["data-source"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: props.close
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          onClick: props.ok
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title", "closable", "onCancel"]))
}
}

})